<template>
  <div class="menu-icon" @click="$emit('click')">
    <i class="ri-menu-line ri-lg"></i>
  </div>
  <!-- <div></div> -->
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.menu-icon {
  position: absolute;
  z-index: 2022;
  right: 1.5rem;
  top: 2rem;
}
</style>
